import { AppDialog, useAppDialog } from "app/utils";

import { AirtableInterestDialog, SocialShareDialog } from "./portfolio";
import { TransactionsDialog, TransactionSettingsDialog, WalletConnectDialog } from "./transactions";
import { ConnectDialog } from "./auth";
import {
    StrategyDeleteDialog,
    StrategyManageEscrowDialog,
    StrategySettingsDialog,
    StrategyTermsDialog
} from "./strategy";
import {
    BorrowDialog,
    BorrowSelectCollateralDialog,
    LendApyDialog,
    LendDialog,
    MarketGuideDialog,
    MultiSelectCollateralDialog,
    SelectTokenDialog,
    UpdateApyAndCollateralDialog
} from "./market-detail";
import { ReferralEnterCodeDialog } from "./points";
import { LoanActionDialog, RefinanceSettingsDialog } from "./loan";
import { WindSettingsDialog } from "./loop";
import { DialectNotificationDialog } from "./dialect";
import { VaultWithdrawSlippageDialog } from "./vault/withdraw/VaultWithdrawSlippageDialog";
import { ManagerAddRewardsDialog, ManagerEditRewardsDialog } from "./manager-view";
import { VaultClaimRewardsDialog, VaultManageEscrowDialog } from "./vault";

export default function AppDialogs() {
    const { openIdentifiers } = useAppDialog();
    if (!openIdentifiers.length) return null;

    return (
        <>
            {openIdentifiers.map((identifier) => (
                <OpenDialog key={identifier} identifier={identifier} />
            ))}
        </>
    );
}

function OpenDialog({ identifier }: { identifier: AppDialog }) {
    switch (identifier) {
        case AppDialog.Connect:
            return <ConnectDialog />;
        case AppDialog.TransactionSender:
            return <TransactionsDialog />;
        case AppDialog.AirtableInterestForm:
            return <AirtableInterestDialog />;
        case AppDialog.StrategyDelete:
            return <StrategyDeleteDialog />;
        case AppDialog.StrategyManageEscrow:
            return <StrategyManageEscrowDialog />;
        case AppDialog.StrategyTerms:
            return <StrategyTermsDialog />;
        case AppDialog.StrategySettings:
            return <StrategySettingsDialog />;
        case AppDialog.MultiSelectCollateral:
            return <MultiSelectCollateralDialog />;
        case AppDialog.SelectToken:
            return <SelectTokenDialog />;
        case AppDialog.BorrowSelectCollateral:
            return <BorrowSelectCollateralDialog />;
        case AppDialog.WalletConnect:
            return <WalletConnectDialog />;

        case AppDialog.ReferralEnterCode:
            return <ReferralEnterCodeDialog />;
        case AppDialog.LoanActions:
            return <LoanActionDialog />;
        case AppDialog.RefinanceSettings:
            return <RefinanceSettingsDialog />;
        case AppDialog.Lend:
            return <LendDialog />;
        case AppDialog.UpdateStrategyApyAndCollateral:
            return <UpdateApyAndCollateralDialog />;
        case AppDialog.Borrow:
            return <BorrowDialog />;

        case AppDialog.MarketGuide:
            return <MarketGuideDialog />;

        case AppDialog.LendApy:
            return <LendApyDialog />;
        case AppDialog.WindSettings:
            return <WindSettingsDialog />;
        case AppDialog.Notifications:
            return <DialectNotificationDialog />;

        case AppDialog.VaultManageEscrow:
            return <VaultManageEscrowDialog />;
        case AppDialog.VaultClaimRewards:
            return <VaultClaimRewardsDialog />;
        case AppDialog.VaultWithdrawSlippage:
            return <VaultWithdrawSlippageDialog />;
        case AppDialog.TransactionSettings:
            return <TransactionSettingsDialog />;
        case AppDialog.ManagerAddRewards:
            return <ManagerAddRewardsDialog />;
        case AppDialog.ManagerEditRewards:
            return <ManagerEditRewardsDialog />;
        case AppDialog.SocialShare:
            return <SocialShareDialog />;
        default:
            return null;
    }
}
